module.exports = __webpack_public_path__ + "static/media/Coursera-wordpress-development-certification.189648c5.png";